import React from 'react';

/**
 * Renders an Elasticsearch highlight fragment ("... <em>match</em> ...")
 * without dangerouslySetInnerHTML: the string is split on <em> markers and the
 * matched parts get a highlight style. Any other markup renders as plain text.
 */
const HighlightedText: React.FC<{ text: string }> = ({ text }) => {
  const parts = text.split(/<\/?em>/);
  return (
    <>
      {parts.map((part, index) => {
        if (index % 2 === 1) {
          return (
            <mark key={index} className="rounded-sm bg-warning/30 px-0.5 font-semibold text-foreground">
              {part}
            </mark>
          );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </>
  );
};

export default HighlightedText;
